import { action, makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
// class ToastData {
//     message: string;
//     warning: boolean;
//     success: boolean;
//     error: boolean;
//     constructor(data: Partial<ToastData>) {
//         this.message = data.message || '';
//         this.warning = data.warning || false;
//         this.success = data.success || false;
//         this.error = data.error || false;
//     }
//}
class ToastService {
    constructor() {
        makeAutoObservable(this);
    }

    @action
    showWarning(msg: string) {
        return toast.warning(msg);
    }
    @action
    showSuccess(msg: string) {
        return toast.success(msg);
    }
    @action
    showError(msg: string) {
        return toast.error(msg);
    }
}

export default new ToastService();
